import { render, staticRenderFns } from "./TheModalCierre.vue?vue&type=template&id=54754156&scoped=true&"
import script from "./TheModalCierre.vue?vue&type=script&lang=js&"
export * from "./TheModalCierre.vue?vue&type=script&lang=js&"
import style0 from "./TheModalCierre.vue?vue&type=style&index=0&id=54754156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54754156",
  null
  
)

export default component.exports